import { ApiResponse, http } from '@config/api';

export interface AdminSwitchUserPayload {
	email: string;
	userType: 'farmer' | 'specialist';
}

export interface AdminUserRole {
	role: 'FARMER' | 'SPECIALIST' | 'ADMIN';
	isVerified: boolean;
	isCompany: boolean;
}

export interface AdminUser {
	email: string;
	isEmailVerified: boolean;
	status: string;
	roles: AdminUserRole[];
	createdAt: string;
	updatedAt: string;
}

export interface AdminSearchUsersResponse {
	users: AdminUser[];
}

export interface AdminSwitchUserResponse {
	accessToken: string;
	refreshToken: string;
	isVerified: boolean;
}

export async function adminSearchUsersService(emailPattern: string) {
	const response = await http.get<ApiResponse<AdminSearchUsersResponse>>(
		'auth',
		`admin/search-users?email=${encodeURIComponent(emailPattern)}`
	);

	return response.data;
}

export async function adminSwitchUserService(payload: AdminSwitchUserPayload) {
	const response = await http.post<ApiResponse<AdminSwitchUserResponse>>(
		'auth',
		'admin/switch-user',
		payload
	);

	return response.data;
}
